import React, { memo } from 'react'

import { CheckboxGroup, CheckboxLabel, EmptyHint, FormLabel, FormRow } from './ui'

/* Lista de vínculos com caixas de seleção — planos atendidos pelo médico,
   especialidades da clínica, clínicas em que o médico atende.

   Guarda os ids como números no estado do Formik, que é o formato que a API
   espera. Um `<select multiple>` devolveria strings e obrigaria cada tela a
   converter na hora de enviar; com checkbox o usuário também vê tudo de uma
   vez, sem precisar segurar Ctrl para marcar mais de um. */
const CampoVinculos = ({ label, name, opcoes, values, setFieldValue, vazio }) => {
  const selecionados = Array.isArray(values[name]) ? values[name] : []

  const alternar = id => {
    const marcado = selecionados.includes(id)
    setFieldValue(
      name,
      marcado ? selecionados.filter(i => i !== id) : [...selecionados, id]
    )
  }

  return (
    <FormRow $full>
      <FormLabel>{label}</FormLabel>
      {opcoes.length === 0 ? (
        <EmptyHint>{vazio || 'Nenhum cadastrado.'}</EmptyHint>
      ) : (
        <CheckboxGroup>
          {opcoes.map(opcao => (
            <CheckboxLabel key={opcao.id}>
              <input
                type='checkbox'
                checked={selecionados.includes(opcao.id)}
                onChange={() => alternar(opcao.id)}
              />
              {opcao.name || '—'}
            </CheckboxLabel>
          ))}
        </CheckboxGroup>
      )}
    </FormRow>
  )
}

export default memo(CampoVinculos)
